<div class="desktop" *ngIf="getLlistaIncidencies.length > 0">

    <div class="dropdown-button" (click)="toggleLlistat()" fxLayout="row" fxLayoutAlign="space-between center" >
        <span class="label" i18n>Lista de incidencias de circulación</span>
        <span><img class="arrow" [class.selected]="getLlistaIncidencies.length > 0 && mostraLlistat" src='assets/img/arrowButton.svg'></span>
    </div>
    
    <div class="list-container">
        <ul [hidden]="!(getLlistaIncidencies.length > 0) || !mostraLlistat" >
            <div *ngFor="let incidencia of getLlistaIncidencies" class="incidencia">
                <app-incidencia-llista [feature]="incidencia" [layer]="incidencia.properties.layer" [map]="map" [infowindow]="infowindow" (clickEmitter)="clickEmitter.emit()">
                </app-incidencia-llista>
                <hr>
            </div>
            
        </ul>
    </div>

</div>

<div class="responsive-container" *ngIf="getLlistaIncidencies.length > 0">

    <div class="dropdown-button" (click)="toggleLlistat()" fxLayout="row" fxLayoutAlign="space-between center">
        <span class="label" i18n>Lista de incidencias de circulación</span>
        <span><img class="arrow" [class.selected]="getLlistaIncidencies.length > 0 && mostraLlistat" src='assets/img/arrowButton.svg'></span>
    </div>
    
    <div class="list-container">
        <ul [hidden]="!(getLlistaIncidencies.length > 0) || !mostraLlistat" >
            <div *ngFor="let incidencia of getLlistaIncidencies" class="incidencia">
                <app-incidencia-llista [feature]="incidencia" [layer]="incidencia.properties.layer" [map]="map" [infowindow]="infowindow" (clickEmitter)="clickEmitter.emit()">
                </app-incidencia-llista>
                <hr>
            </div>
            
        </ul>
    </div>
    
</div>

<div class="responsive-landscape-container" *ngIf="getLlistaIncidencies.length > 0">

    <div class="dropdown-button" (click)="toggleLlistat()" fxLayout="row" fxLayoutAlign="space-between center" >
        <span class="label" i18n>Incidencias</span>
        <span><img class="arrow" [class.selected]="getLlistaIncidencies.length > 0 && mostraLlistat" src='assets/img/arrowButton.svg'></span>
    </div>
    
    <div class="list-container" [hidden]="!(getLlistaIncidencies.length > 0) || !mostraLlistat">

        <ul>
            <div *ngFor="let incidencia of getLlistaIncidencies" class="incidencia" [class.expanded]="expandMenu">
                <app-incidencia-llista [feature]="incidencia" [layer]="incidencia.properties.layer" [map]="map" [infowindow]="infowindow" (clickEmitter)="clickEmitter.emit()">
                </app-incidencia-llista>
                <hr>
            </div>
            
        </ul>
        <div class="expand-button">
            <img src="{{expandMenu ? 'assets/img/collapse.svg' : 'assets/img/expand.svg'}}" (click)="toggleExpand()">
        </div>
        
    </div>

    
    
</div>




